/* eslint-disable @next/next/no-img-element */
"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import Image from "next/image";
import { Feedback } from "@spheron/ui-library";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";
import { PrivyProvider, usePrivy } from "@privy-io/react-auth";
import InitAnalytics from "@/components/InitAnalytics";
import Footer from "@/components/Footer";
import MaintanenceIcon from "@/assets/spheron-specific/maintainance.svg";
import CloseIcon from "@/assets/general/close-square-1.svg";
import Arrow from "@/assets/general/arrow-right-1.svg";
import { defineChain } from "viem";
import { networkMap, NetworkType, networkType } from "@/config";
import { baseSepolia } from "viem/chains";
import Link from "@/components/Link";

function Banner() {
  const { authenticated, user } = usePrivy();
  const [showBanner, setShowBanner] = useState(
    typeof window !== "undefined" &&
      localStorage.getItem("showBanner") === "true"
  );

  const [privyToken, setPrivyToken] = useState(
    typeof window !== "undefined" && localStorage.getItem("privy:token")
  );

  useEffect(() => {
    if (authenticated && user) {
      localStorage.setItem("showBanner", "true");
      setShowBanner(true);
    } else if (!privyToken) {
      localStorage.removeItem("showBanner");
      setShowBanner(false);
    }
  }, [authenticated, user, privyToken]);

  // if (!showBanner) return null;

  return (
    <div className="w-full">
      <Feedback
        feedbackType="success"
        // icon={<MaintanenceIcon className="w-6 h-6" />}
        subTitle={
          <div className="text-[12px] flex flex-row gap-x-2 items-center">
            Road to TGE is LIVE! Every node deployment on Supernoderz now earns
            xpSPON points. Join now 🎉{" "}
            <Link
              size="small"
              isBold
              type="primary"
              text="Learn more here"
              onClick={() => {
                window.open("https://tge.spheron.network");
              }}
              rightIcon={<Arrow />}
            />
          </div>
        }
        title=""
        showClose={false}
        withShadow={false}
        position="center"
        size="compact"
      />
    </div>
  );
}

export default function Template({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (
      !localStorage?.getItem("privy:token") &&
      !pathname?.includes("auth") &&
      !pathname?.includes("callback") &&
      pathname !== "/"
    ) {
      router.replace("/");
    }
  }, [router, pathname]);

  const network = networkMap[networkType as NetworkType];
  const spheronChain = defineChain({
    id: network.chainId,
    name: network.chainName,
    network: network.chainName,

    nativeCurrency: {
      decimals: network.nativeCurrency.decimals,
      name: network.nativeCurrency.name,
      symbol: network.nativeCurrency.symbol,
    },
    rpcUrls: {
      default: {
        http: network.rpcUrls,
      },
    },
    blockExplorers: {
      default: {
        name: "Explorer",
        url: network.blockExplorerUrls[0],
      },
    },
  });

  const defaultAppComponent = (
    <div>
      <Banner />
      {children}
      <Footer />
    </div>
  );
  return (
    <>
      <PrivyProvider
        appId={process.env.NEXT_PUBLIC_PRIVY_APP_ID || ""}
        clientId={process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID || ""}
        config={{
          appearance: {
            accentColor: "#6A6FF5",
            theme: "#141416",
            showWalletLoginFirst: false,
            logo: "/logo.png",
          },

          loginMethods: [
            "email",
            "google",
            // "github",
            // "twitter",
            // "wallet"
          ],
          embeddedWallets: {
            createOnLogin: "all-users",
            requireUserPasswordOnCreate: false,
          },
          supportedChains: [spheronChain],
        }}
      >
        <InitAnalytics />
        <SmartWalletsProvider>{defaultAppComponent}</SmartWalletsProvider>
      </PrivyProvider>
    </>
  );
}
